import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import React from 'react';
function hasReactChildren(children) {
  if (!children) {
    return false;
  }
  var childrenCount = React.Children.toArray(children).filter(Boolean).length;
  return childrenCount > 0;
}
export default hasReactChildren;